module.exports = __webpack_public_path__ + "static/media/documentation.0e0585e2.svg";